/* eslint-disable react/destructuring-assignment */

import Toolbar from "@material-ui/core/Toolbar";
import * as React from "react";
import DateRangePicker, { DateRangeValue } from "../../../DateRangePicker";
import SearchBox from "../../../SearchBox";
import styles from "./DataTableToolbar.module.scss";
import LinkProps from "../../../../Models/CommonProps/LinkModel";
import { IconType } from "../../../Icon";
import DataTableAddButton from "./DataTableAddButton";
import exportUserReport from "../../../../views/UserManagement/http/exportUserReport";
import LoadingOverlay from "../../../../views/PublicDirectory/components/LoadingOverlay";
import { IconButton, Tooltip, withStyles } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import UserRole from "../../../../Models/user/UserRole";
import { getUserId, getUserRole, isMegatronProUser } from "../../../../Authentication/Auth";
import { connect } from "react-redux";
import { RootState } from "../../../../store/reducers";
import TableInputFilter from "../../../../Models/common/TableInputFilter";
import { dispatch } from "../../../App/App";
import { clearTableInputs } from "../../../../store/details/actions/getTableFilterInputs";
import { upgradeToProText } from "../../../../constants/ToolTipsText";
import { DataTableQueryParams } from "../..";
import SimpleMenu from "../../../VerifyReportManagement/Index";
import { ClearAllButton } from "../../../Button/button";
import { trackEvent } from "../../../../util/googletagmanager/GTM";
export interface DataTableToolbarOptions {
  readonly searchField?: {
    readonly enable?: boolean;
    readonly placeholder?: string;
  };
  readonly enableDateRange?: boolean;
  readonly newEntityLink?: LinkProps;
}



interface DataTableToolbarProps {
  readonly tableFilterInputs?:TableInputFilter
  readonly options?: DataTableToolbarOptions;
  readonly setDateRange: (val: DateRangeValue) => void;
  readonly dateRange: DateRangeValue;
  readonly dataManager: { readonly changeSearchText: (val: string) => void };
  readonly onSearchChanged: (val: string) => void;
  readonly isMegatronLite?: boolean
  readonly reportFilter?: DataTableQueryParams
  readonly enableExportButton?: boolean
}

class DataTableToolbar extends React.Component<
  DataTableToolbarProps,
  { searchText: string ,loading:boolean}
> {
  constructor(props: any) {
    super(props);
    const filterDatastring= this.props.tableFilterInputs;
    const filterData=filterDatastring?filterDatastring:null;
    const str = window.location.pathname
    const pieces = str.split('/')
    const UrlCheck = pieces[pieces.length - 1];
    this.state = {
      searchText:(UrlCheck == "verify" && filterData?.searchTerm)?filterData.searchTerm:props.searchText,
      loading: false,
    };
  }

  onSearchChange = (searchText: string) => {
    this.props.dataManager.changeSearchText(searchText)
    this.setState({ searchText })
  };
  componentDidMount() {

  if (typeof window !== 'undefined') {
    const str = window.location.pathname
    const pieces = str.split('/')
    const UrlCheck = pieces[pieces.length - 1];
   
   if( UrlCheck == "verify")
{
  const filterDatastring= this.props.tableFilterInputs;
  const filterData=filterDatastring?filterDatastring:null;

    if(filterData?.searchTerm)
    {
    this.setState({ searchText:filterData.searchTerm });
    
    }
  }
  }
}
  render() {
  const str = window.location.pathname
  const pieces = str.split('/')
  const UrlCheck = pieces[pieces.length - 1];
  const userTab= UrlCheck=="user"?true:false;
   const verifyTab= UrlCheck=="verify"?true:false;
  const adminUser=getUserRole();
  const showExport=adminUser==='BRCGS Admin'?true:false;
  
  const { searchText } = this.state;
  
  const { options, dateRange, setDateRange } = this.props;
    const { enableDateRange, searchField, newEntityLink } = options ?? {};
    const { enable = true, placeholder = "Search name" } = searchField ?? {};
  
    const PDFTooltip = withStyles({
    tooltip: {
      color: "white",
      backgroundColor: "grey",
      width:"200px",
      fontSize:"14px"
    }
  })(Tooltip);
  const {isMegatronLite, reportFilter, enableExportButton} = this.props
    const megatronProUser = getUserId() != undefined &&  isMegatronProUser() ;
   function ClearAll(): void {
      
         window.location.reload()
    }
    return (
      <Toolbar className={styles.tableToolbar}>
        
        {enable && (
          <SearchBox
            searchString={searchText}
            onUpdateSearch={(val) => {this.onSearchChange(val);
         
                      }
                      }
                       
                    handleClick={() => {
                        this.props.onSearchChanged(searchText);
                        localStorage.setItem("UserSearchPageNumber", "0");
                if (isMegatronLite || megatronProUser) {
  if(verifyTab){
      
              trackEvent('Feature_Interaction',{
                              User_Role:isMegatronLite?"Company user Lite":megatronProUser?"Company user Pro":"Other User",
                              Tab_Section:"Certificate Tracker",
                              Type:"Search bar",
                              Feature_Function:"Search for audit records",
                              UserInput:searchText})
                          }

            }}
          }
            placeHolderString={placeholder}
          />
        )}
        {verifyTab && (  <div style={{display: 'flex', justifyContent:'flex-start'}}><ClearAllButton className="clear-all-filter" onClick={()=>ClearAll()}></ClearAllButton></div>)}
        {enableExportButton && <PDFTooltip title={isMegatronLite ? upgradeToProText : ""}>
            <IconButton onMouseEnter={()=>{
                          if(isMegatronLite)
                            {
                             
                       trackEvent('Feature_Interaction',{
                        User_Role:"Company user Lite",
                        Tab_Section:"Certificate Tracker",
                        Type:"Button/Hover message",
                        Feature_Function:"Export list-Pro feature (blocked)",
                        UserInput:"Click/Hover"})
                            }
                          }
                        }
              className="sizeSmall"
              style={{
                opacity: isMegatronLite ? 0.50 : 1,
                cursor: isMegatronLite ? "not-allowed" : "pointer",
                maxWidth: '150px',
                marginLeft: 'auto'
              }}
            >
              <FontAwesomeIcon icon={faDownload} opacity={isMegatronLite ? 0.50 : 1}/>
              <SimpleMenu searchterms={reportFilter}></SimpleMenu>
            </IconButton>
          </PDFTooltip>}
          
          {enableDateRange && (
          <DateRangePicker
            fromValue={dateRange[0]}
            toValue={dateRange[1]}
            onChange={setDateRange}
          />
        )}
        {newEntityLink && (
          <div className={styles.actions}>
            <DataTableAddButton
              label={newEntityLink.label}
              link={newEntityLink.link}
              type={IconType.ADD}
              permissionTargets={newEntityLink.permissionAreas}
              state={newEntityLink.stateInfo}
            />
          </div>
        )}
       
                      {userTab && showExport&&  (
        <div style={{display: 'flex', justifyContent:'flex-end',paddingRight:10}}>
          <div style={{display: 'flex', justifyContent:'flex-end',paddingRight:10}}>
          <LoadingOverlay isLoading={this.state.loading} />
          
        <IconButton
  onClick={()=>
  {
    this.setState({ loading: true });
            
              exportUserReport()
            
                  .finally(() => this.setState({ loading: false}));
  }
  }
>
  <FontAwesomeIcon icon={faDownload} />
  <span className="add">Export User</span>
</IconButton>



           </div>
         
                      </div>)}
      
      </Toolbar>
    );
  }
}
const mapStateToProps=(state: RootState)=>({
  tableFilterInputs: state.details.tableFilterInputs,
})
export default connect(mapStateToProps)(DataTableToolbar);